import APIConfig from 'config/api';
import { IProfile } from 'typings/profile/profile';
import { APIService } from '../axiosInstance';
import { profileAPIAdapter } from 'apiAdapters/profile/profileAPIAdapter';

export interface UpdatePhoneNumberResponseModel {
  otpExpiresIn: string;
}

const profileAPI = {
  fetchMe: () => {
    return APIService.get<IProfile>(`${APIConfig.crmApi}/users/profile`).then(
      (response) => profileAPIAdapter.fetchProfile(response.data),
    );
  },

  updatePhoneNumber: (otp: string, phoneNumber: string) => {
    return APIService.post(`${APIConfig.authApi}/users/primary-phone/change`, {
      otp,
      phoneNumber,
    }).then((response) => response.data);
  },
};

export { profileAPI };
